import { api } from '../../../utils'
import {
  CARRELLO,
  CHECKPERSONALIZZAZIONE,
  PERSONALIZZAZIONICARRELLO,
  RIGHECARRELLO,
} from '../../../utils/endpoint'
import { Button } from '../../atoms'
import FormRadio from '../../atoms/FormRadio/FormRadio'
import NewModal from '../../molecules/NewModal/NewModal'
import { useState, useEffect, useContext } from 'react'
import _ from 'lodash'
import useTrans from '../../../hooks/useTrans'
import { displayNotification } from '../../atoms/Notifica/Notifica'
import { useRouter } from 'next/router'
import { QuantitaContext } from '../../../context/QuantitaContext'
import { trackingGAEventProdotto } from '../../../utils/gtm'

export function useDuplicaPersonalizzazione(riga, carrello) {
  const router = useRouter()
  const [isVisible, setVisible] = useState(false)
  const [personalizzioniDisponibili, setPersonalizzioniDisponibili] = useState()

  const AddToCart = async (personalizzazione_carrello_id) => {
    const _riga = Object.assign(riga, {})

    const new_riga = _.set(_riga, 'personalizzazione_carrello_id', personalizzazione_carrello_id)

    const params = { ...new_riga }

    const EsisteRiga = carrello
      ? carrello?.personalizzazioni_carrello
          ?.filter((item) => item?.id === personalizzazione_carrello_id)?.[0]
          ?.righe_carrello?.filter((r) => r?.articolo?.codice === riga?.articolo?.codice)?.[0]
      : null

    EsisteRiga
      ? await api
          .patch(RIGHECARRELLO + EsisteRiga?.id + '/', {
            quantita: riga?.quantita + EsisteRiga?.quantita,
          })
          .then((res) =>
            api
              .delete(RIGHECARRELLO + riga?.id)
              .then(() => router.reload())
              .catch((err) => console.log(err))
          )
          .catch((err) => console.log(err))
      : await api
          .put(RIGHECARRELLO + riga.id + '/', params)
          .then((res) => {
            router.reload()
            displayNotification(
              'new.pers.add.to.main',
              'Hai aggiunto la personalizzazione nel Carrello',
              'success'
            )
          })
          .catch((err) => displayNotification('error', err.message, 'error'))
  }

  const checkPersonalizzazioniDisponibili = async (id) => {
    const params = {
      prodotto_id: id,
    }
    const { data } = await api
      .get(CHECKPERSONALIZZAZIONE, { params })
      .catch((err) => console.log(err))

    if (data?.pers?.length > 0) {
      setPersonalizzioniDisponibili(_.uniqBy(data?.pers, 'id'))
      setVisible(true)
      return data?.pers?.length > 0 ? _.uniqBy(data?.pers, 'id') : null
    } else {
      return null
    }
  }

  const ModalDuplicaPersonalizzazione = ({ onClose }) => {
    return (
      <DuplicaPersonalizzazione
        AddToCart={AddToCart}
        onClose={onClose}
        personalizzazioniDisponibili={personalizzioniDisponibili}
        isVisible={isVisible}
        setVisible={setVisible}
        riga={riga}
      ></DuplicaPersonalizzazione>
    )
  }

  return {
    checkPersonalizzazioniDisponibili,
    ModalDuplicaPersonalizzazione,
  }
}

export const DuplicaPersonalizzazione = ({
  personalizzazioniDisponibili,
  onClose,
  isVisible,
  setVisible,
  AddToCart,
  riga,
}) => {
  const t = useTrans()

  const [selected, setSelected] = useState(null)
  const [step, setStep] = useState(0)
  const [posizione, setPosizione] = useState()

  useEffect(() => {
    setStep(0)

    return () => {
      setStep(0)
    }
  }, [])

  const handleNome = (obj) => {
    const nome = obj?.toString().split('_')
    const numero_max = personalizzazioniDisponibili
      ?.filter((item) => item?.nome_lavorazione?.split('_')[0] === nome[0])
      ?.reduce(
        (prev, curr) => {
          const value = curr?.nome_lavorazione?.split('_')[1] || 0
          return Math.max(prev, parseInt(value))
        },
        [0]
      )
    const new_nome = nome[0] + '_' + (parseInt(numero_max) + 1)
    return new_nome
  }

  const handleSubmit = () => {
    const createNew = selected?.posizioni?.length > 1 && posizione < 2 ? true : false

    const Personalizzazione = { ...selected }
    const PersonalizzazioneSelezionata = createNew ? selected?.posizioni[posizione] : undefined
    const PersonalizzazioneModificata = createNew
      ? _.set(Personalizzazione, 'posizioni', [PersonalizzazioneSelezionata])
      : undefined

    const nome = handleNome(
      PersonalizzazioneModificata?.nome_lavorazione
        ? PersonalizzazioneModificata?.nome_lavorazione
        : selected?.nome_lavorazione
    )

    const params = PersonalizzazioneModificata
      ? {
          nome_lavorazione: nome,
          riconfezionamento: PersonalizzazioneModificata?.riconfezionamento,
          posizioni: PersonalizzazioneModificata?.posizioni?.map((posizione) => ({
            ...posizione,
            logo_file_id: posizione?.logo_file,
          })),
          stesso_logo: true,
        }
      : undefined

    createNew
      ? api
          .post(`${PERSONALIZZAZIONICARRELLO}`, params)
          .then((response) => {
            console.log(params)
            AddToCart(response.data.id)
            setStep(0)
            setVisible(false)
          })
          .catch((err) => (console.log(err), setVisible(false)))
      : (AddToCart(selected?.id), setStep(0), setVisible(false))
  }
  return (
    <NewModal
      visible={isVisible}
      title={t('Desideri duplicare la personalizzazione?')}
      text={t(
        'Le seguenti personalizzazioni salvate possono essere applicate alle referenze da te selezionate'
      )}
      actions={[
        <Button
          label={step > 0 ? t('Indietro') : t('Crea nuova personalizzazione')}
          variant="secondary"
          size="medium"
          onClick={() => {
            if (step === 0) {
              onClose && onClose()
              setVisible(false)
              trackingGAEventProdotto(
                'duplicate_customization',
                'nessun_posizione',
                'crea_nuova',
                riga?.articolo?.titolo || '',
                riga?.articolo?.prodotto_codice || ''
              )
            } else {
              setStep(0)
              setPosizione(null)
            }
          }}
        />,
        <Button
          label={step > 0 ? t('Duplica Personalizzazione') : t('Procedi')}
          variant="primary"
          disabled={
            step === 0 ? (selected === null ? true : false) : posizione === null ? true : false
          }
          size="medium"
          onClick={() => {
            if (step === 0) setStep(1)
            else {
              let pos = ''
              if (posizione === 0) pos = 'posizione_1'
              else if (posizione === 1) pos = 'posizione_2'
              else if (posizione === 2) pos = 'entrambe'
              trackingGAEventProdotto(
                'duplicate_customization',
                pos,
                'applica',
                riga?.articolo?.titolo || '',
                riga?.articolo?.prodotto_codice || ''
              )
              handleSubmit()
            }
          }}
        />,
      ]}
    >
      {step === 0 ? (
        <div
          style={{ margintop: 20, maxHeight: 450, overflowY: 'scroll', textAlign: 'left' }}
          className="u-scrollable"
        >
          {personalizzazioniDisponibili?.map((item) => (
            <div style={{ margin: '5px 0px' }}>
              <FormRadio
                key={item?.id}
                label={item?.nome_lavorazione}
                checked={selected?.id === item?.id}
                onClick={() => setSelected(item)}
              />
            </div>
          ))}
        </div>
      ) : (
        <div style={{ margintop: 20, textAlign: 'left' }}>
          <p style={{ textTransform: 'uppercase', marginBottom: 10, color: '' }}>
            <strong>Applica {selected?.nome_lavorazione}</strong>
          </p>
          <FormRadio
            checked={posizione === 0}
            label={t('A Posizione 1')}
            onClick={() => setPosizione(0)}
          />
          {selected?.posizioni?.length > 1 && (
            <>
              <FormRadio
                checked={posizione === 1}
                label={t('A Posizione 2')}
                onClick={() => setPosizione(1)}
              />
              <FormRadio
                checked={posizione === 2}
                label={t('A entrambe le posizioni')}
                onClick={() => setPosizione(2)}
              />
            </>
          )}
        </div>
      )}
    </NewModal>
  )
}
